import { CLIENT } from '../constant/actionTypes';

const getClientData = (state, action) => {
  switch (action.type) {
    case CLIENT.DATA.INITIATE:
      return { isFetching: false };
    case CLIENT.DATA.SUCCESS:
      return { isFetching: true, data: action.payload };
    case CLIENT.DATA.ERROR:
      return { isFetching: true, data: action.payload };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getClientData;
